import React, { Component } from 'react';
import { Segment, Header, Image, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import LogIconImage from './log_icon.png';
import ClaimsIconImage from './claims_icon.png';
import CoverageIconImage from './coverage_icon.png';

class QuickLinksWidget extends Component {
    render() {
        const isDisabled = this.props.user.companies.filter(company => company.memberType.toUpperCase() == 'E').length > 0 ? false : true;

        return (
            <div>
                <Header as='h4' attached='top' block>
                    Quick Links
                </Header>
                <Segment attached>
                    <Button.Group basic>
                        <Link to={isDisabled || !this.props.configBenefit.featuresConfig.allowLOG ? '#' : '/app/submitelog'}>
                            <Button disabled={isDisabled || !this.props.configBenefit.featuresConfig.allowLOG}>
                                <Image src={LogIconImage} fluid/>
                                Request Letter of Guarantee
                            </Button>
                        </Link>
                        <Link to={isDisabled || !this.props.configBenefit.featuresConfig.allowEclaimSubmit? '#' : '/app/submitclaim'}>
                            <Button disabled={isDisabled || !this.props.configBenefit.featuresConfig.allowEclaimSubmit}>
                                <Image src={ClaimsIconImage} fluid/>
                                Submit Claim
                            </Button>
                        </Link>
                        <Link to="/app/profile">
                            <Button>
                                <Image src={CoverageIconImage} fluid/>
                                Coverage Plans
                            </Button>
                        </Link>
                    </Button.Group>
                </Segment>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user.user,
        configBenefit: state.user.configBenefit,
    };
}

export default connect(mapStateToProps)(QuickLinksWidget);
